import React, { useEffect, useState, useContext } from "react";
import Input from "../../atoms/Input";
import Button from "../../atoms/Button";
import { ReactComponent as Mail } from "../../svgs/mail.svg";
import { ReactComponent as Eye } from "../../svgs/eye.svg";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../../redux/slices/auth-slice";
import { Link, useNavigate } from "react-router-dom";
import { TopLoaderContext } from "../../../context/TopLoader";

const LoginForm = ({ userType }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loadingRef } = useContext(TopLoaderContext);

  const { user, signInLoading, isAuth } = useSelector(
    (state) => state.authReducer
  );

  const userEmail = user ? user.email : "";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (!signInLoading) loadingRef.current.complete();
  }, [signInLoading, loadingRef]);

  useEffect(() => {
    if (isAuth) {
      navigate("/");
    }
  }, [isAuth]);

  const onEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const onPasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();
    loadingRef.current.continuousStart();
    dispatch(login({ email, password, userType }));
  };

  return (
    <form
      className="w-full flex flex-col gap-y-6 mt-16"
      onSubmit={onSubmitHandler}
    >
      <p className="text-gray-400 text-sm self-end">
        Logged in as: <span className="text-blue-800">{userEmail}</span>
      </p>
      <Input
        label="Email"
        type="email"
        className="w-full"
        Icon={Mail}
        onChange={onEmailChange}
        value={email}
        required={true}
      />
      <Input
        label="Password"
        type="password"
        className="w-full"
        Icon={Eye}
        onChange={onPasswordChange}
        value={password}
        required={true}
      />
      <p className="text-gray-400 text-sm self-end">
        Forgot your Password?
        <Link to="forgot-password">
          <span className="text-blue-800 ml-2">Reset</span>
        </Link>
      </p>

      <Button
        type="submit"
        color="blue"
        varient="rounded"
        className="w-fit py-2 px-16 mx-auto text-2xl tracking-widest text-white mt-12"
        disabled={signInLoading}
      >
        Log in
      </Button>
    </form>
  );
};

export default LoginForm;
